export default __webpack_public_path__ + "static/media/HM.29dbf5c7.png";